<div class="w-full h-full flex flex-col overflow-hidden bg-gray-100 p-6">
  <!-- Header -->
  <app-material-header [title]="'language.title' | translate" [showSearch]="true"
    [searchPlaceholder]="'language.searchPlaceholder' | translate" [(searchTerm)]="searchTerm"
    [actionTemplate]="actions"></app-material-header>

  <ng-template #actions>
    <button (click)="openAddModal()"
      class="bg-indigo-600 text-white px-4 py-2 rounded-lg shadow-sm hover:bg-indigo-700 font-medium text-sm flex items-center gap-2 transition-all active:scale-95 whitespace-nowrap">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M5 12h14" />
        <path d="M12 5v14" />
      </svg>
      {{ 'language.addKey' | translate }}
    </button>
  </ng-template>

  <!-- Main Content -->
  <app-material-table class="flex-1 min-h-0" [headers]="headers()" [data]="filteredTranslations()"
    [rowTemplate]="rowTpl" [enablePagination]="true" [pageSize]="15" key="key"></app-material-table>

  <ng-template #rowTpl let-item>
    <tr class="border-b border-gray-100 last:border-b-0 hover:bg-gray-50/50 transition-colors text-sm">
      <td class="px-4 py-3   text-xs text-gray-600 w-1/3">{{ item.key }}</td>
      <td class="px-4 py-3 text-gray-800 w-1/3">{{ item.en }}</td>
      <td class="px-4 py-3 text-gray-800 w-1/3">{{ item.ko }}</td>
      <td class="px-4 py-3 w-16">
        <button (click)="openEditModal(item)"
          class="text-gray-400 hover:text-indigo-600 transition-colors p-1 hover:bg-indigo-50 rounded-full">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z" />
            <path d="m15 5 4 4" />
          </svg>
        </button>
      </td>
    </tr>
  </ng-template>

  <!-- Modal -->
  @if (isModalOpen()) {
  <div class="fixed inset-0 z-40 bg-black/50 backdrop-blur-sm" (click)="closeModal()"></div>
  <div class="fixed inset-0 z-50 flex items-center justify-center p-4" (click)="closeModal()">
    <div class="bg-white rounded-2xl shadow-2xl w-full max-w-lg" (click)="$event.stopPropagation()">
      <div class="flex justify-between items-center p-5 border-b border-gray-200">
        <h3 class="text-lg font-bold text-gray-800">{{ isNew() ? ('language.addKey' | translate) : ('language.editKey' |
          translate) }}</h3>
        <button (click)="closeModal()" class="text-gray-400 hover:text-gray-600"><svg xmlns="http://www.w3.org/2000/svg"
            width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <path d="M18 6 6 18" />
            <path d="m6 6 12 12" />
          </svg></button>
      </div>
      @if (editItem(); as item) {
      <div class="p-6 space-y-4">
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">{{ 'language.key' | translate }}</label>
          <input type="text" [ngModel]="item.key"
            (ngModelChange)="editItem.set({ key: $event, en: item.en, ko: item.ko })" [disabled]="!isNew()"
            placeholder="e.g. common.save"
            class="w-full px-4 py-2 border rounded-lg outline-none transition-all   text-sm"
            [class]="isNew() ? 'border-gray-300 focus:ring-2 focus:ring-indigo-200 focus:border-indigo-600' : 'bg-gray-100 text-gray-500 border-gray-200 cursor-not-allowed'" />
          @if (isNew()) {
          <p class="text-xs text-gray-500 mt-1">{{ 'language.keyHelp' | translate }}</p>
          }
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">{{ 'language.enValue' | translate }}</label>
            <textarea [ngModel]="item.en" (ngModelChange)="editItem.set({ key: item.key, en: $event, ko: item.ko })"
              class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-200 focus:border-indigo-600 outline-none transition-all min-h-[100px]"></textarea>
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">{{ 'language.krValue' | translate }}</label>
            <textarea [ngModel]="item.ko" (ngModelChange)="editItem.set({ key: item.key, en: item.en, ko: $event })"
              class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-200 focus:border-indigo-600 outline-none transition-all min-h-[100px]"></textarea>
          </div>
        </div>
      </div>
      }
      <div class="px-6 py-4 bg-gray-50 border-t border-gray-200 flex justify-end gap-3">
        <button (click)="closeModal()"
          class="px-4 py-2 bg-white border border-gray-300 text-gray-700 text-sm font-bold rounded-lg hover:bg-gray-50 transition-colors">{{
          'common.cancel' | translate }}</button>
        <button (click)="saveTranslation()"
          class="px-6 py-2 bg-indigo-600 text-white text-sm font-bold rounded-lg hover:bg-indigo-700 shadow-sm transition-colors">{{
          'common.save' | translate }}</button>
      </div>
    </div>
  </div>
  }
</div>